import { FC } from "react";

import {
  Button,
  ButtonSize,
  ButtonVariant,
} from "@repo/edtech-ui-kit";

import { OriginAsset, t } from "../../../../../../origins";

import st from "./CheckTestCover.module.scss";

type Props = {
  onClickCheckTest: () => void,
  onClickFinishTest: () => void,
  isSurvey: boolean,
  isFinishLoading?: boolean,
};

export const CheckTestCover: FC<Props> = ({
  onClickCheckTest,
  onClickFinishTest,
  isSurvey,
  isFinishLoading = false,
}) => {
  const submitSuffix = isSurvey ?
    t("checkTestCover.submitSurveySuffix") :
    t("checkTestCover.submitTestSuffix");

  return (
    <div className={st.wrap}>
      <OriginAsset
        assetKey="checkTestCoverIcon"
        className={st.icon}
      />
      <h2 className={st.title}>
        {t("checkTestCover.title")}
      </h2>
      <p className={st.description}>
        {t("checkTestCover.description")}
      </p>
      <div className={st.actions}>
        <Button
          size={ButtonSize.Medium}
          variant={ButtonVariant.Outline}
          onClick={onClickCheckTest}
        >
          {t("checkTestCover.backToPrefix")}
          {" "}
          {
            isSurvey ?
              t("checkTestCover.backToSurvey") :
              t("checkTestCover.backToTest")
          }
        </Button>
        <Button
          disabled={isFinishLoading}
          size={ButtonSize.Medium}
          variant={ButtonVariant.Primary}
          onClick={onClickFinishTest}
        >
          {t("checkTestCover.submitPrefix")}
          {
            submitSuffix ?
              ` ${submitSuffix}` :
              ""
          }
        </Button>
      </div>
    </div>
  );
};
